import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import { router } from "./helpers";
import { dictionary } from "./helpers";
import store from "./store";
import Axios from "axios";
import VuetifyGoogleAutocomplete from "vuetify-google-autocomplete";
import { apiKey } from "./helpers/config";
import VueExcelXlsx from "vue-excel-xlsx";

Vue.prototype.$http = Axios;
const user = localStorage.getItem("user");
if (user && user.token) {
  Vue.prototype.$http.defaults.headers.common["Authorization"] = user.token;
}

Vue.config.productionTip = false;

Vue.use(VuetifyGoogleAutocomplete, {
  apiKey: apiKey
});

Vue.use(VueExcelXlsx);

new Vue({
  vuetify,
  router,
  store,

  render: h => h(App),

  created() {
    if (!this.$store.state.user.activeUser) {
      this.reloadUser();
    }
    this.$store.commit("booking/resetBooking");
  },
  methods: {
    async reloadUser() {
      const jwt = JSON.parse(
        localStorage.getItem(dictionary.constants.authentication.jwt)
      );
      if (jwt) {
        const userId = jwt.userId;
        await this.$store.dispatch("user/getUser", { userId });

        this.$store.commit("booking/resetBooking");
      }
    }
  }
}).$mount("#app");
